var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logout",
    clipPath: "url(#clip0_1385_73451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.625 9.625L2.625 11.375C2.625 11.859 3.01602 12.25 3.5 12.25L10.5 12.25C10.984 12.25 11.375 11.859 11.375 11.375L11.375 9.625C11.375 9.14102 11.766 8.75 12.25 8.75C12.734 8.75 13.125 9.14102 13.125 9.625L13.125 11.375C13.125 12.8242 11.9492 14 10.5 14L3.5 14C2.05078 14 0.875 12.8242 0.875 11.375L0.875 9.625C0.875 9.14102 1.26602 8.75 1.75 8.75C2.23398 8.75 2.625 9.14102 2.625 9.625Z",
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.1043 5.9582L7.74648 9.31602C7.54961 9.51289 7.27891 9.625 7 9.625C6.72109 9.625 6.45039 9.51289 6.25352 9.31602L2.8957 5.9582C2.7207 5.7832 2.625 5.54805 2.625 5.30195C2.625 4.79062 3.04062 4.375 3.55195 4.375L5.25 4.375L5.25 0.875C5.25 0.391015 5.64102 -2.5064e-07 6.125 -2.29485e-07L7.875 -1.5299e-07C8.35898 -1.31834e-07 8.75 0.391015 8.75 0.875L8.75 4.375L10.448 4.375C10.9594 4.375 11.375 4.79062 11.375 5.30195C11.375 5.54805 11.2766 5.7832 11.1043 5.9582Z",
    fill: "#1D1D1D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1385_73451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 14) rotate(-90)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.3262dc9a37a99c4d74db041a79d3bc31.svg";
export { ForwardRef as ReactComponent };